/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `A` - 비주얼라이저
 * `B` - 가사 후크
 * `C` - ASMR
 */
export type UsedTemplateEnum =
  (typeof UsedTemplateEnum)[keyof typeof UsedTemplateEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedTemplateEnum = {
  A: "A",
  B: "B",
  C: "C",
} as const;
